import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-undo",
  "use": "icon-undo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-undo\"><path d=\"M178.7 661.3h214.1c7.1 0 10.7-8.6 5.7-13.7l-74.3-74.3C363.9 504.6 447.7 448 554.7 448c142.9 0 209.9 105.1 213.2 205.6.1 4.3 3.7 7.8 8 7.8h69.4c4.5 0 8.1-3.7 8-8.2-3.7-145.7-106.1-290.5-298.6-290.5-131.8 0-235.4 64.5-292.5 148.8l-77.9-77.9c-5-5-13.7-1.5-13.7 5.7v214.1c.1 4.4 3.6 7.9 8.1 7.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol